import * as React from 'react';
import { SVGProps } from 'react';
const SvgMessage = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7204 7.83196H7.16184V9.74368H16.7204V7.83196Z"
      fill="current"
    />
    <path
      d="M13.8529 11.6554H7.16184V13.5671H13.8529V11.6554Z"
      fill="current"
    />
    <path
      d="M2.38281 3.05286L21.5001 3.05273V18.3465H13.1621L7.16217 21.9472V18.3465H2.38364L2.38281 3.05286ZM12.6326 16.4348H19.5883V4.96445H4.29459V16.4348H9.07389V18.5692L12.6326 16.4348Z"
      fill="current"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMessage;
